import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import ProcessImprovementsResources from "../resources/ProcessImprovementsResources";
import UserResources from "../resources/UserResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { event } from "jquery";
import Select from 'react-select';
import { connect } from "react-redux";
import { loginSuccess, logout } from "../redux/actions/LoggedInAction";
import {ACCESS_DENIED} from '../Messages'

function ProcessImprovements({isLoggedIn, loggedInUser}){
    const location = useLocation();

    const [improvements, setImprovements] = useState([])
    const [users, setUsers] = useState([])
    const [selectedOption, setSelectedOption] = useState({}); // stores the entire user details
    const [suggestedImprovement, setSuggestedImprovement] = useState('');
    const resources = new ProcessImprovementsResources()
  
    // Function to handle dropdown change
    const handleDropdownChange = (event) => {
      setSelectedOption(event.value);
    };
  
    // Function to handle textbox change
    const handleSuggestedImprovementChange = (event) => {
        setSuggestedImprovement(event.target.value);
    };
  
    // Function to handle button clicks
    const handleAddImprovementButtonClick = () => {   
        // confirm suggestion is not empty
        if(suggestedImprovement.trim().length < 1){
            toast.error("Please enter a valid suggestion.")
            return;
        }   

        //  confirm dialog before submission
        if(!window.confirm("Are you sure you want to submit this suggestion?")){
            return;
        }
      
      let suggestion = {};
      suggestion['user_id'] = loggedInUser['id']
      if(suggestedImprovement.length > 1 )
      {
        suggestion['name'] = suggestedImprovement
      }
      suggestion['date_added'] = moment( new Date()).format('YYYY-MM-DD HH:mm:ss') 
      
      resources.post(suggestion).then(res => {
        
            if (res.error.length < 1) {
                toast.success("Successfully updated")
            }else if(res.error === 'Unconfirmed User') {
                toast.error("You do not have permission to make this change.")
            }
             else {
                //toast.error("Operation Failed: " + res.error);
                toast.error("An Issue occured, please retry")
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });

        setTimeout(() => {
            window.location.href = window.location.origin + '/improvements';
          }, 200);
    };

    // Function to handle button clicks
    const handleDeleteImprovementButtonClick = (id) => {      
         //  confirm dialog before deletion
            if(!window.confirm("Are you sure you want to delete this suggestion?")){
                return;
            }
      let suggestion = {};
      suggestion['id'] = Number(id)
      suggestion['user_email'] = loggedInUser['email']

      resources.delete_improvement(suggestion).then(res => {
        if (res.error.length < 1) {
            toast.success("Successfully updated")
            setTimeout(() => {
                window.location.href = window.location.origin + '/improvements';
              }, 200);
        }else if(res.error === 'You do not have permission to make this change') {
            toast.error("You do not have permission to make this change.")
        }
         else {
            //toast.error("Operation Failed: " + res.error);
            toast.error("An Issue occured, please retry")
        }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });

    };

    const handleMarkDoneToggle = (improvement) => {
        const newDone = improvement['done'] !== 'True';
        let payload = { id: improvement['id'], done: newDone };
        resources.put(payload).then(res => {
            if (res.error.length < 1) {
                window.location.href = window.location.origin + '/improvements';
            } else {
                toast.error("An issue occurred, please retry")
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });
    };

    const loadImprovements = () => {
        return resources.get()
    }

  
    const loadUsers = () => {
        let userResources = new UserResources()
        return userResources.get_admin()
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        //const searchParamss = queryString.parse(location.search)
        
         loadImprovements().then(response => {
            setImprovements(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });


        loadUsers().then(response => {
            setUsers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
        
    }, []);

    let members = []  //dropdown values is the user information
    users.map((user, index) => (
        members.push({value: user, label: user['firstname'] + " " + user['lastname'] })
    ))
    return(        
        <Fragment>
            <Topbar/>
             <div className="hero-area">
             <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Process Improvements</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }                             
                        </div>
                    </div>
                </div>
            </div>

            {/* <!--Main Content> */}
            <div id="main-container">
                <div class="content">
                {
                    isLoggedIn ? 
                    <div className="container">
                        <div className="spacer-20"></div>

                        <TableContainer component={Paper} style={{boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '8px'}}>
                            <Table>
                                <TableHead>
                                <TableRow style={{backgroundColor: '#003165'}}>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Action to Take</TableCell>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Added by</TableCell>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Date Added</TableCell>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Status</TableCell>
                                    {loggedInUser !== null && loggedInUser['role.name'] === 'admin' && <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Done By</TableCell>}
                                    {loggedInUser !== null && loggedInUser['role.name'] === 'admin' && <TableCell></TableCell>}
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {improvements.map((improvement, idx) => {
                                    const isDone = improvement['done'] === 'True';
                                    const isAdmin = loggedInUser !== null && loggedInUser['role.name'] === 'admin';
                                    return (
                                        <TableRow key={improvement['id']} style={{backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                                            <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{improvement['name']}</TableCell>
                                            <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{improvement['user.firstname'] + " " + improvement['user.lastname']}</TableCell>
                                            <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{moment(improvement['date_added']).format('DD MMMM YYYY')}</TableCell>
                                            <TableCell>
                                                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                    {isAdmin && (
                                                        <input
                                                            type="checkbox"
                                                            checked={isDone}
                                                            onChange={() => handleMarkDoneToggle(improvement)}
                                                            style={{accentColor: '#35ab7c', width: '16px', height: '16px', cursor: 'pointer'}}
                                                        />
                                                    )}
                                                    <span style={{
                                                        display: 'inline-block',
                                                        padding: '3px 10px',
                                                        borderRadius: '12px',
                                                        fontSize: 'clamp(11px, 3vw, 12px)',
                                                        fontWeight: 'bold',
                                                        backgroundColor: isDone ? '#e8f8f0' : '#fff3cd',
                                                        color: isDone ? '#35ab7c' : '#856404'
                                                    }}>{isDone ? 'Done' : 'Pending'}</span>
                                                </div>
                                            </TableCell>
                                            {isAdmin && <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)', color: '#555'}}>{isDone && improvement['done_by_user.firstname'] ? improvement['done_by_user.firstname'] + " " + improvement['done_by_user.lastname'] : '-'}</TableCell>}
                                            {isAdmin && <TableCell>
                                                <button style={{backgroundColor: '#d80000', color: '#fff', border: 'none', borderRadius: '4px', padding: '5px 12px', cursor: 'pointer', fontSize: 'clamp(12px, 3.2vw, 13px)'}} onClick={() => handleDeleteImprovementButtonClick(improvement['id'])}>Delete</button>
                                            </TableCell>}
                                        </TableRow>
                                    )
                                })}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div className="spacer-40"></div>

                        {/* Add Suggestions Card */}
                        <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '24px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 16px', fontSize: 'clamp(16px, 4vw, 18px)'}}>Add your suggestions</h3>
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end'}}>
                                <div style={{flex: '1 1 250px', minWidth: '220px'}}>
                                    <input
                                        type="text"
                                        value={suggestedImprovement}
                                        onChange={handleSuggestedImprovementChange}
                                        placeholder="Enter details"
                                        style={{width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                    />
                                </div>
                                <button
                                    onClick={handleAddImprovementButtonClick}
                                    style={{backgroundColor: '#8ccd80', color: '#003165', border: 'none', borderRadius: '4px', padding: '8px 22px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                >Add</button>
                            </div>
                        </div>
                                :
                                <p></p>
                        
                           
                    </div> : <></>
                }
                </div>
            </div>
            <Footer/>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessImprovements);